import { Row, Col, Typography } from 'antd'
import { memo, useMemo, useCallback } from 'react'
import RenderField from './utils/RenderField'

const { Title } = Typography

export const normalizeTitle = (title: any): string => {
  if (!title) return ''

  if (title.includes('CIF')) {
    return title
  }

  const spacedTitle = title
    .replace(/[_-]/g, ' ') // Replace special characters with spaces
    .replace(/([a-z])([A-Z])/g, '$1 $2')
    .replace(/([A-Z])([A-Z][a-z])/g, '$1 $2')

  return spacedTitle
    .trim()
    .replace(/\s+/g, ' ') // Remove extra spaces
    .toLowerCase()
    .split(' ')
    .map((word: any) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ')
}

const ObjectFieldTemplate = memo((props: any) => {
  const { properties, schema, uiSchema = {}, formContext } = props

  const connectedPairs = uiSchema?.connectedPairs || []

  const groupedFields = properties.reduce((acc: any, field: any) => {
    const fieldSchema = schema.properties[field.name] || {}
    const group = fieldSchema.group || 'other'

    const isConnected = connectedPairs.some(
      ([key1, key2]: [string, string]) => field.name === key1 || field.name === key2
    )

    if (!acc[group]) {
      acc[group] = []
    }
    acc[group].push({
      ...field,
      hideTitle: fieldSchema.hideTitle || false,
      connect: isConnected || fieldSchema.connect || false,
    })

    return acc
  }, {})

  const sortedGroups = Object.entries(groupedFields).sort((a: any, b: any) => {
    const orderA = schema.groups?.[a[0]]?.order || 999
    const orderB = schema.groups?.[b[0]]?.order || 999
    return orderA - orderB
  })

  // Function to calculate column span dynamically
  const getColSpan = (field: any) => {
    const width = field.content.props.schema?.width
    if (width === 'full') return { xs: 24, sm: 24, md: 24, lg: 24 }
    if (width === 'half') return { xs: 24, sm: 24, md: 12, lg: 12 }
    return { xs: 24, md: 12, xl: formContext?.divide ? 12 : width ? width : 6 }
  }

  // Memoized rendering function for normal fields
  const renderNormalFields = useCallback(
    (fields: any[]) => {
      let mergedFields: any[] = []
      let tempGroup: any[] = []

      fields.forEach((field: any, index: number) => {
        if (field.connect) {
          tempGroup.push(field)
          if (!fields[index + 1]?.connect) {
            mergedFields.push([...tempGroup])
            tempGroup = []
          }
        } else {
          mergedFields.push([field])
        }
      })

      return mergedFields.map((group: any, index: number) => (
        <Col {...getColSpan(group[0])} key={`merged-${index}`}>
          {group.map((field: any) => (
            <div key={field.name}>{field.content}</div>
          ))}
        </Col>
      ))
    },
    [formContext]
  )

  // Rendering section by section based on group
  const renderSection = (groupKey: any, fields: any) => {
    const groupTitle = schema.groups?.[groupKey]?.title || groupKey
    const hideGroupTitle = fields.some((field: any) => field.hideTitle)

    const normalFields = fields.filter(
      (field: any) =>
        !schema.properties[field.name]?.isMapField &&
        schema.properties[field.name]?.type !== 'array'
    )
    const arrayFields = fields.filter(
      (field: any) => schema.properties[field.name]?.type === 'array'
    )
    const mapFields = fields.filter((field: any) => schema.properties[field.name]?.isMapField)

    return (
      <RenderField
        key={groupKey}
        groupTitle={groupTitle}
        hideGroupTitle={hideGroupTitle}
        normalFields={normalFields}
        arrayFields={arrayFields}
        mapFields={mapFields}
        renderNormalFields={renderNormalFields}
        normalizeTitle={normalizeTitle}
      />
    )
  }

  return (
    <div>
      {sortedGroups.map(
        ([groupKey, fields]: any) => groupKey !== '' && renderSection(groupKey, fields)
      )}
    </div>
  )
})

export default ObjectFieldTemplate

// import { Row, Col, Typography, Divider } from 'antd';
// import { useEffect, useRef, useState } from 'react';
// import useIntersectionObserver from './hooks/useIntersectionObserver';
// import useElementSize from './hooks/useElementSize';
// import RenderField from './utils/RenderField';

// const { Title } = Typography;

// export const normalizeTitle = (title: any): string => {
//   if (!title) return '';

//   const spacedTitle = title
//     .replace(/[^a-zA-Z0-9]/g, ' ') // Replace special characters with spaces
//     .replace(/([a-z])([A-Z])/g, '$1 $2')
//     .replace(/([A-Z])([A-Z][a-z])/g, '$1 $2');

//   return spacedTitle
//     .trim()
//     .replace(/\s+/g, ' ') // Remove extra spaces
//     .toLowerCase()
//     .split(' ')
//     .map((word: any) => word.charAt(0).toUpperCase() + word.slice(1))
//     .join(' ');
// };

// const ObjectFieldTemplate = (props: any) => {
//   const { properties, schema, uiSchema, formContext } = props;

//   const connectedPairs = uiSchema?.connectedPairs || [];

//   const groupedFields = properties.reduce((acc: any, field: any) => {
//     const fieldSchema = schema.properties[field.name] || {};
//     const group = fieldSchema.group || 'other';

//     const isConnected = connectedPairs.some(
//       ([key1, key2]: [string, string]) => field.name === key1 || field.name === key2
//     );

//     if (!acc[group]) {
//       acc[group] = [];
//     }
//     acc[group].push({
//       ...field,
//       hideTitle: fieldSchema.hideTitle || false,
//       connect: isConnected || fieldSchema.connect || false,
//     });

//     return acc;
//   }, {});

//   const sortedGroups = Object.entries(groupedFields).sort((a: any, b: any) => {
//     const orderA = schema.groups?.[a[0]]?.order || 999;
//     const orderB = schema.groups?.[b[0]]?.order || 999;
//     return orderA - orderB;
//   });

//   const getColSpan = (field: any) => {
//     const width = field.content.props.schema?.width;
//     if (width === 'full') return { xs: 24, sm: 24, md: 24, lg: 24 };
//     if (width === 'half') return { xs: 24, sm: 24, md: 12, lg: 12 };
//     return { xs: 24, md: 12, xl: formContext?.divide ? 12 : width ? width : 6 };
//   };

//   const renderNormalFields = (fields: any) => {
//     let mergedFields: any[] = [];
//     let tempGroup: any[] = [];

//     fields.forEach((field: any, index: number) => {
//       if (field.connect) {
//         tempGroup.push(field);
//         if (!fields[index + 1]?.connect) {
//           mergedFields.push([...tempGroup]);
//           tempGroup = [];
//         }
//       } else {
//         mergedFields.push([field]);
//       }
//     });

//     return mergedFields.map((group: any, index: number) => (
//       <Col {...getColSpan(group[0])} key={`merged-${index}`}>
//         {group.map((field: any) => (
//           <div key={field.name}>
//             {field.content}
//           </div>
//         ))}
//       </Col>
//     ));
//   };

//   const renderSection = (groupKey: any, fields: any) => {
//     const groupTitle = schema.groups?.[groupKey]?.title || groupKey;
//     const hideGroupTitle = fields.some((field: any) => field.hideTitle);

//     const normalFields = fields.filter(
//       (field: any) => !schema.properties[field.name]?.isMapField && schema.properties[field.name]?.type !== 'array'
//     );
//     const arrayFields = fields.filter((field: any) => schema.properties[field.name]?.type === 'array');
//     const mapFields = fields.filter((field: any) => schema.properties[field.name]?.isMapField);

//     return (
//       <RenderField
//         key={groupKey}
//         groupTitle={groupTitle}
//         hideGroupTitle={hideGroupTitle}
//         normalFields={normalFields}
//         arrayFields={arrayFields}
//         mapFields={mapFields}
//         renderNormalFields={renderNormalFields}
//         normalizeTitle={normalizeTitle}
//       />

//     );
//   };

//   return (
//     <div >
//       {sortedGroups.map(([groupKey, fields]: any) => groupKey !== '' && renderSection(groupKey, fields))}
//     </div>
//   );
// };

// export default ObjectFieldTemplate;

// import React, { useRef, useEffect, useState, useCallback } from 'react';
// import { Row, Col, Typography, Divider } from 'antd';

// const { Title } = Typography;

// export const normalizeTitle = (title: any): string => {
//   if (!title) return '';

//   const spacedTitle = title
//     .replace(/[^a-zA-Z0-9]/g, ' ')
//     .replace(/([a-z])([A-Z])/g, '$1 $2')
//     .replace(/([A-Z])([A-Z][a-z])/g, '$1 $2');

//   return spacedTitle
//     .trim()
//     .replace(/\s+/g, ' ')
//     .toLowerCase()
//     .split(' ')
//     .map((word: any) => word.charAt(0).toUpperCase() + word.slice(1))
//     .join(' ');
// };

// const ObjectFieldTemplate = (props: any) => {
//   const { properties, schema, uiSchema, formContext } = props;

//   const connectedPairs = uiSchema?.connectedPairs || [];
//   const sectionRefs = useRef<Record<string, HTMLElement | null>>({});
//   const [visibleSections, setVisibleSections] = useState<Set<string>>(new Set());

//   const groupedFields = properties.reduce((acc: any, field: any) => {
//     const fieldSchema = schema.properties[field.name] || {};
//     const group = fieldSchema.group || 'other';

//     const isConnected = connectedPairs.some(
//       ([key1, key2]: [string, string]) => field.name === key1 || field.name === key2
//     );

//     if (!acc[group]) {
//       acc[group] = [];
//     }

//     acc[group].push({
//       ...field,
//       hideTitle: fieldSchema.hideTitle || false,
//       connect: isConnected || fieldSchema.connect || false,
//     });

//     return acc;
//   }, {});

//   const sortedGroups = Object.entries(groupedFields).sort((a: any, b: any) => {
//     const orderA = schema.groups?.[a[0]]?.order || 999;
//     const orderB = schema.groups?.[b[0]]?.order || 999;
//     return orderA - orderB;
//   });

//   const getColSpan = (field: any) => {
//     const width = field.content.props.schema?.width;
//     if (width === 'full') return { xs: 24, sm: 24, md: 24, lg: 24 };
//     if (width === 'half') return { xs: 24, sm: 24, md: 12, lg: 12 };
//     return { xs: 24, md: 12, xl: formContext?.divide ? 12 : width ? width : 6 };
//   };

//   const renderNormalFields = (fields: any) => {
//     let mergedFields: any[] = [];
//     let tempGroup: any[] = [];

//     fields.forEach((field: any, index: number) => {
//       if (field.connect) {
//         tempGroup.push(field);
//         if (!fields[index + 1]?.connect) {
//           mergedFields.push([...tempGroup]);
//           tempGroup = [];
//         }
//       } else {
//         mergedFields.push([field]);
//       }
//     });

//     return mergedFields.map((group: any, index: number) => (
//       <Col {...getColSpan(group[0])} key={`merged-${index}`}>
//         {group.map((field: any) => (
//           <div key={field.name}>
//             {field.content}
//           </div>
//         ))}
//       </Col>
//     ));
//   };

//   const renderSection = (groupKey: string, fields: any) => {
//     const groupTitle = schema.groups?.[groupKey]?.title || groupKey;
//     const hideGroupTitle = fields.some((field: any) => field.hideTitle);

//     const normalFields = fields.filter(
//       (field: any) => !schema.properties[field.name]?.isMapField && schema.properties[field.name]?.type !== 'array'
//     );
//     const arrayFields = fields.filter((field: any) => schema.properties[field.name]?.type === 'array');
//     const mapFields = fields.filter((field: any) => schema.properties[field.name]?.isMapField);

//     const isVisible = visibleSections.has(groupKey);

//     return (
//       <div
//         key={groupKey}
//         ref={(el) => (sectionRefs.current[groupKey] = el)}
//         style={{ minHeight: '10vh', marginBottom: '20px' }}
//       >
//         {!hideGroupTitle && groupTitle !== 'other' && (
//           <>
//             <Title level={4} style={{ marginTop: '25px', lineHeight: '5px' }}>
//               {normalizeTitle(groupTitle)}
//             </Title>
//             <Divider style={{ marginTop: '3px', marginBottom: '15px' }} />
//           </>
//         )}

//         {isVisible && (
//           <>
//             {normalFields.length > 0 && (
//               <Row gutter={[10, 10]} style={{ marginBottom: '.5rem' }}>
//                 {renderNormalFields(normalFields)}
//               </Row>
//             )}

//             {arrayFields.length > 0 && (
//               <Row gutter={[10, 10]}>
//                 {arrayFields.map((field: any) => (
//                   <Col span={24} style={{ marginBottom: '.5rem' }} key={field.name}>
//                     {field.content}
//                   </Col>
//                 ))}
//               </Row>
//             )}

//             {mapFields.length > 0 && (
//               <Row gutter={[10, 10]}>
//                 {mapFields.map((field: any) => (
//                   <Col span={24} key={field.name}>
//                     <div>{field.content}</div>
//                   </Col>
//                 ))}
//               </Row>
//             )}
//           </>
//         )}
//       </div>
//     );
//   };

//   // Intersection Observer setup
//   useEffect(() => {
//     const observerOptions = {
//       root: null,
//       rootMargin: '0px',
//       threshold: 0.25,
//     };

//     const observer = new IntersectionObserver((entries) => {
//       setVisibleSections((prev) => {
//         const updated = new Set(prev);
//         entries.forEach((entry) => {
//           const key = Object.entries(sectionRefs.current).find(([_, val]) => val === entry.target)?.[0];
//           if (!key) return;
//           if (entry.isIntersecting) {
//             updated.add(key);
//           } else {
//             updated.delete(key);
//           }
//         });
//         return new Set(updated);
//       });
//     }, observerOptions);

//     Object.values(sectionRefs.current).forEach((ref) => {
//       if (ref) observer.observe(ref);
//     });

//     return () => observer.disconnect();
//   }, [sortedGroups]);

//   return (
//     <div>
//       {sortedGroups.map(([groupKey, fields]: any) =>
//         groupKey !== '' ? renderSection(groupKey, fields) : null
//       )}
//     </div>
//   );
// };

// export default ObjectFieldTemplate;

// import { Row, Col, Typography, Divider } from 'antd'

// const { Title } = Typography
// export const normalizeTitle = (title: any) => {
//   if (!title) return ''

//   const spacedTitle = title
//     .replace(/[^a-zA-Z0-9]/g, ' ') // Replace special characters with spaces
//     .replace(/([a-z])([A-Z])/g, '$1 $2')
//     .replace(/([A-Z])([A-Z][a-z])/g, '$1 $2')

//   return spacedTitle
//     .trim()
//     .replace(/\s+/g, ' ') // Remove extra spaces
//     .toLowerCase()
//     .split(' ')
//     .map((word: any) => word.charAt(0).toUpperCase() + word.slice(1))
//     .join(' ')
// }

// const ObjectFieldTemplate = (props: any) => {
//   const { properties, schema } = props
//   // Group properties by their group
//   const groupedFields = properties.reduce((acc: any, field: any) => {
//     const fieldSchema = schema.properties[field.name] || {}
//     const group = fieldSchema.group || 'other'
//     if (!acc[group]) {
//       acc[group] = []
//     }
//     acc[group].push({ ...field, hideTitle: fieldSchema.hideTitle || false })
//     return acc
//   }, {})

//   // Sort groups by their order
//   const sortedGroups = Object.entries(groupedFields).sort((a, b) => {
//     const orderA = schema.groups?.[a[0]]?.order || 999
//     const orderB = schema.groups?.[b[0]]?.order || 999
//     return orderA - orderB
//   })

//   const getColSpan = (field: any, totalFields: number) => {
//     const width = field.content.props.schema?.width // Get the width from the schema

//     // Return spans based on width property
//     if (width === 'full') {
//       return { xs: 24, sm: 24, md: 24, lg: 24 } // Full-width
//     } else if (width === 'half') {
//       return { xs: 24, sm: 24, md: 12, lg: 12 } // Half-width
//     }

//     // Default to a third-width if no specific width is defined
//     return {
//       xs: 24,
//       md: 12,
//       xl: props?.formContext?.divide ? 12 : width ? width : 6,
//     }
//   }

//   const renderArrayField = (field: any) => (
//     <Col span={24}>
//       {field.content}
//     </Col>
//   )

//   const renderNormalField = (field: any, totalFields: any) => (
//     <Col {...getColSpan(field, totalFields)} key={field.name}>
//       {field.content}
//     </Col>
//   )

//   const renderMapField = (field: any) => (
//     <Col span={24} key={field.name}>
//       <div>{field.content}</div>
//     </Col>
//   )

//   const renderSection = (groupKey: any, fields: any) => {
//     const groupTitle = schema.groups?.[groupKey]?.title || groupKey
//     const hideGroupTitle = fields.some((field: any) => field.hideTitle)

//     // Filter normal fields, array fields, and map fields
//     const normalFields = fields.filter(
//       (field: any) =>
//         !schema.properties[field.name]?.isMapField &&
//         schema.properties[field.name]?.type !== 'array'
//     )
//     const displayTitle = fields.filter((field: any) => schema.properties)
//     const arrayFields = fields.filter(
//       (field: any) => schema.properties[field.name]?.type === 'array'
//     )
//     const mapFields = fields.filter((field: any) => schema.properties[field.name]?.isMapField)

//     return (
//       <div key={groupKey}>
//         {!hideGroupTitle && groupTitle !== 'other' && (
//           <>
//             <Title
//               level={4}
//               style={{ marginTop: "25px", lineHeight: "5px" }}
//             >
//               {normalizeTitle(groupTitle)}
//             </Title>
//             <Divider style={{ marginTop: '3px', marginBottom: '15px' }} />
//           </>
//         )}

//         {normalFields.length > 0 && (
//           <>
//             <Row gutter={[10, 10]} style={{ margin: '0 0 10px 0' }}>
//               {normalFields.map((field: any) => renderNormalField(field, normalFields.length))}
//             </Row>
//           </>
//         )}

//         {arrayFields.length > 0 && (
//           <Row gutter={[10, 10]}>{arrayFields.map((field: any) => renderArrayField(field))}</Row>
//         )}

//         {mapFields.length > 0 && (
//           <Row gutter={[10, 10]}>{mapFields.map((field: any) => renderMapField(field))}</Row>
//         )}
//       </div>
//     )
//   }

//   return (
//     <div>
//       {sortedGroups.map(([groupKey, fields]) => groupKey !== '' && renderSection(groupKey, fields))}
//     </div>
//   )
// }

// export default ObjectFieldTemplate
